import axios from 'axios' 
const API = axios.create({baseURL:'http://46.105.28.78:4000'});


export const signin = (FormData)=> API.post('/admin/signin',FormData);